import React from 'react'

export default function PauseIcon({ classList }) {
  return (
    <svg className={classList} viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1C0 0.447716 0.447715 0 1 0H4.25C4.80228 0 5.25 0.447715 5.25 1V17C5.25 17.5523 4.80228 18 4.25 18H1C0.447715 18 0 17.5523 0 17V1ZM8.75 1C8.75 0.447716 9.19771 0 9.75 0H13C13.5523 0 14 0.447715 14 1V17C14 17.5523 13.5523 18 13 18H9.75C9.19771 18 8.75 17.5523 8.75 17V1Z" fill="#1976D2" />
    </svg>
  )
}
